export const WALLET_RECHARGE_KEY = "ql_teacher_wallet_recharge_attempt";
export const RECHARGE_EXPIRATION_MS = 2 * 60 * 1000;
export const RECHARGE_ACTIVE_STATES = new Set(["INITIALIZING", "UNCERTAIN", "EN_ATTENTE", "PENDING", "PROCESSING"]);
export const RECHARGE_SUCCESS_STATES = new Set(["CONFIRMEE", "SUCCESS", "CONFIRMED"]);
export const RECHARGE_FAILED_STATES = new Set(["ECHOUEE", "FAILED", "CANCELLED", "EXPIRED"]);

export const normalizeRechargeStatus = (data) => String(data?.status || data?.recharge_status || "EN_ATTENTE").toUpperCase();

export const readWalletRechargeAttempt = () => {
  try {
    const value = JSON.parse(localStorage.getItem(WALLET_RECHARGE_KEY) || "null");
    return value?.amount && value?.status ? value : null;
  } catch {
    return null;
  }
};

export const persistWalletRechargeAttempt = (attempt) => localStorage.setItem(WALLET_RECHARGE_KEY, JSON.stringify(attempt));
export const clearWalletRechargeAttempt = () => localStorage.removeItem(WALLET_RECHARGE_KEY);
